
export const SET_CATALOG = 'SET_CATALOG';

export const SET_PRICING = 'SET_PRICING';

export const SET_PRODUCTS = 'SET_PRODUCTS';

export const CHANGE_IO_SHIP_OPTIONS = 'CHANGE_IO_SHIP_OPTIONS';

export const SET_SELECTED_PACK = 'SET_SELECTED_PACK';

export const SELECTED_PACK = 'SELECTED_PACK';

export const CLEAR_SELECTED_PACK = 'CLEAR_SELECTED_PACK';

export const CLEAR_SELECTED_PACK_ITEM = 'CLEAR_SELECTED_PACK_ITEM';



// WEBPACK FOOTER //
// ./src/store/actions/types/productActionTypes.js